import { TooltipProvider as BaseTooltipProvider } from "@/components/Base/Tooltip";
import { TooltipProviderProps } from "@radix-ui/react-tooltip";

export const TooltipProvider = ({
  children,
  ...props
}: TooltipProviderProps) => {
  return <BaseTooltipProvider {...props}>{children}</BaseTooltipProvider>;
};
